import React, {useState} from 'react';

import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {Link, useParams} from "react-router-dom";
import {formatDate} from "../../../utils/utils";

import {
    Level3
} from "../../../services/metadata.service";

// name: display on preview top
// key: column# of excel sheet
// json_key: key for posting data to api
const columns = [
    {name: 'Code', key: 0, json_key: 'code', data_key: 'code'},
    {name: 'Full Name', key: 1, json_key: 'full_name', data_key: 'full_name'},
    {name: 'Definition', key: 2, json_key: 'definition', data_key: 'definition'},
    {name: 'DQC#', key: 4, json_key: 'dqc_no', data_key: 'dqc_no'},
    // {name: 'Color Code', key: 4, json_key: 'color_code', data_key: 'color_code'},
    {name: 'Category6', key: 3, json_key: 'category_6', data_key: 'category_6'},
    {name: 'DQM#', key: 5, json_key: 'dqm_no', data_key: 'dqm_no'},
    {name: 'Stakeholder#', key: 6, json_key: 'stakeholder_no', data_key: 'stakeholder_no'},
    {name: 'DQA#', key: 7, json_key: 'dqa_no', data_key: 'dqa_no'},
]

const tableCols = [
    {
        label: 'Code',
        field: 'code', width: 150
    },
    {
        label: 'Full Name',
        field: 'full_name', width: 150
    },
    {
        label: 'Definition',
        field: 'definition', sort: 'disabled', width: 150
    },
    {
        label: 'DQC#',
        field: 'dqc_no', width: 150
    },
    {
        label: 'Color Code',
        field: 'color_code', width: 150
    },
    {
        label: 'Category6',
        field: 'category_6', width: 150
    },
    {
        label: 'DQM#',
        field: 'dqm_no', width: 150
    },
    {
        label: 'Stakeholder#',
        field: 'stakeholder_no', width: 150
    },
    {
        label: 'DQA#',
        field: 'dqa_no', width: 150
    },
    // {
    //     label: '[AGG] Level 6',
    //     field: 'code_agg_l6', width: 150
    // },
    {
        label: '[AGG] Assess 8',
        field: 'code_agg_a8', width: 150
    },
    {
        label: 'Created',
        field: 'createdAt', width: 150
    },
    {
        label: 'Updated',
        field: 'updatedAt', width: 150
    },
    {
        label: 'Actions',
        field: 'actions', sort: 'disabled', searchable: false
    }
]


export default function Level3Page() {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    const table_row__additional_rendering = (row) => {
        const lvl3_code_data = row.code;
        // row.code_agg_l6 = <Link to={`/meta_data/level6/q=${lvl3_code_data}`} className={'meta-data-table-entity-link'} >{lvl3_code_data}</Link>;
        row.code_agg_a8 = <Link to={`/meta_data/assess8/q=${lvl3_code_data}`} className={'meta-data-table-entity-link'} >{lvl3_code_data}</Link>;

        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;

        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Level 5 [Modules]'}
            modal_title={'Level 5 - Data Preview'}
            sheet_name={'Level5 (Competency)'}
            columns={columns}
            tableCols={tableCols}
            search_query={search_query}
            tableSpRender={table_row__additional_rendering}
            listAPI={Level3.listData}
            postAPI={Level3.postData}
            deleteAPI={Level3.deleteEntity}
            updateAPI={Level3.updateEntity}
            preRemoveAPI={Level3.preRemoveCheck}
        />
    );
}
